import type { PortfolioEducationItem } from '../../firebase/types/portfolio.types';
import { Band, SectionIndex } from './ui';

export default function EducationSection({
  education,
  index,
}: {
  education: PortfolioEducationItem[];
  index: string;
}) {
  return (
    <Band id="education">
      <SectionIndex index={index} title="Education" />
      <div className="grid gap-3 md:grid-cols-2">
        {education.map((item, i) => {
          const place = [item.institution, item.location].filter(Boolean).join(' · ');
          const meta = [item.period, item.grade].filter(Boolean).join(' · ');
          return (
            <article key={`${item.degree}-${i}`} className="panel p-4 md:p-5">
              <h3 className="text-lg font-semibold">{item.degree}</h3>
              {place ? <p className="mt-2 text-sm leading-relaxed text-muted">{place}</p> : null}
              {meta ? <p className="mt-1 text-sm text-faint">{meta}</p> : null}
            </article>
          );
        })}
      </div>
    </Band>
  );
}
